module.exports = __webpack_public_path__ + "static/media/s_snowboard.cdf1af69.mp3";